import React, { Component } from "react";
import { FormControl, DropdownButton, Dropdown, Button } from "react-bootstrap";
import Toggle from "react-toggle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWifi, faPlane, faBars } from "@fortawesome/free-solid-svg-icons";

import ConfigService from "../../../../../services/ConfigService";

import gcLogo from "../../../../../assets/images/logos/glasschain-mra-logo.png";
import NavbarCollapse from "react-bootstrap/esm/NavbarCollapse";



export default class HeaderPanel extends Component {
  constructor(props) {
    super(props);

    this.configService = new ConfigService();

    this.state =
    {
      customerLogoImgSrc: "",
      dropdownClass: ""
    }

  }

  componentDidMount() {
    let customerLogoImgSrc = this.configService.getCustomerLogoImagePath(this.props.userSession.gcid);
    this.setState({
      customerLogoImgSrc: customerLogoImgSrc,
      dropdownClass: ""
    });
  }


  showDropdown() {
    console.log("clicked")
    if (this.state.dropdownClass !== "showdrop") {
      this.setState({
        dropdownClass: "showdrop"
      })
    } else {
      this.setState({
        dropdownClass: ""
      })
    }
  }

  onHomeRouteRequest() {
    return
  }

  render() 
  {

    var locations = <option key={1}>loading...</option>;
    if ((this.props.userSession) && (this.props.userSession.allowedLocations))
    {
      var sortedLocations = this.props.userSession.allowedLocations.sort((a, b) => a.name.localeCompare(b.name));
      if (!this.props.userSession.allowedLocations.some(loc => loc.name.toLowerCase()==="all"))
      {
        sortedLocations.unshift({"id": "0", "name": "all"});
      }
      locations = sortedLocations.map((loc, index) => (<option key={index}>{loc.name}</option>));
    }
    var currentLocation = (this.props.userSession && this.props.userSession.locationInfo && this.props.userSession.locationInfo.warehouse) ? this.props.userSession.locationInfo.warehouse.name: "";

    var sublocations = [];
    var currentSublocation = "";
    if (currentLocation.toLowerCase() !== "all")
    {
      if (this.props.userSession.locationInfo)
      {
        sublocations = this.props.userSession.locationInfo.auxInfo.sublocations.map((sub, index) => (<option key={index}>{sub.sublocationName}</option> ));
      }
      currentSublocation = (this.props.userSession && this.props.userSession.locationInfo && this.props.userSession.locationInfo.sublocation) ? this.props.userSession.locationInfo.sublocation.sublocationName: "";
    }
   



    return (

      <div id="homenav">
        <div>
          <img
            src={gcLogo}
            alt="Glasschain"
            onClick={(e) => this.props.onHomePageRequest(e)}
          />
        </div>

        <div>
          <img
            src={this.state.customerLogoImgSrc}
            alt="Logo"
          />
        </div>

        <div>

          { (this.props.editable) ?
          <Toggle 
            defaultChecked={this.props.onlineInfo.isAirplaneMode}
            icons={{
              checked: <FontAwesomeIcon icon={faPlane} color="white" size="sm"/>,
              unchecked: <FontAwesomeIcon icon={faPlane} color="white" size="sm"/>,
            }}
            onChange= {this.props.onToggleAirplaneMode}
          />
          : <span/>
          }
          &nbsp;&nbsp;
          <FontAwesomeIcon
            icon={faWifi}
            color={(this.props.onlineInfo) ? 
                (this.props.onlineInfo.isOnline) ? "green" : "grey"
              : "grey"}
          />
        </div>

        <div id="headeruserinfo">
          {this.props.userSession.uid}
          { (this.props.editable) ?
          <FormControl
            id="headerlocdropdown"
            as="select"
            placeholder="location"
            type="dropdown"
            autoComplete="on"
            value={currentLocation}
            name="location"
            onChange={ev => this.props.onUpdateLocationId(ev.target.value)}
          >
          {locations}
        </FormControl> 
        : 
          <span>&nbsp;-&nbsp;{this.props.userSession.locationInfo.name}</span>
        
        }
        </div>

        <div id="headeruserinfo">
          &nbsp;
          { (this.props.editable && currentLocation.toLowerCase() !== "all" && currentLocation !== "") ?
          <FormControl
            id="headersublocdropdown"
            as="select"
            placeholder="sublocation"
            type="dropdown"
            autoComplete="on"
            value={currentSublocation}
            name="location"
            onChange={ev => this.props.onUpdateSublocationId(ev.target.value)}
          >
          {sublocations}
        </FormControl> 
        :  <span/>
        
        }
        </div>



        <div id="homedropdown">

          <Button onClick={this.props.onContextMenuRequest}><FontAwesomeIcon icon={faBars} color="white"/></Button>

        </div>
      </div>


    )
  }
}